export default __webpack_public_path__ + "static/media/gerioox-caixa.f20ea598.png";